"use client";
import React from "react";
import { BackArrow } from "./Icons";
import { useRouter } from "next/navigation";

const Back = ({ text }: { text?: string }) => {
  const router = useRouter();
  const handleGoBack = () => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      router.back();
    } else {
      router.push("/");
    }
  };
  return (
    <button
      onClick={handleGoBack}
      className="flex gap-2 items-center cursor-pointer"
    >
      <span className="size-4 sm:size-5 md:size-6">
        <BackArrow />
      </span>
      <p className="font-semibold ff_poppins text-sm sm:text-base md:text-lg leading-5 sm:leading-6 md:leading-7 lg:leading-8 xl:leading-9">
        {text ? text : "Back"}
      </p>
    </button>
  );
};

export default Back;
